@if (!showEventPicker() && !showProviderChooser()) {
  <h1 mat-dialog-title data-cy="add-meeting-bot-dialog_title">Add Maz to this meeting</h1>
  <ninety-button
    data-cy="add-meeting-bot-dialog_close-button"
    flat
    icon
    class="close-dialog-btn"
    ariaLabel="Close dialog"
    (click)="cancel()">
    <terra-icon icon="x" />
  </ninety-button>
}

<mat-dialog-content
  class="dialog-container"
  [class.dialog-container--unpadded]="showEventPicker() || showProviderChooser()">
  @if (showProviderChooser()) {
    <ninety-choose-calendar-provider-dialog
      [integrations]="providerChooserIntegrations()"
      (closed)="onProviderChooserClosed()" />
  } @else if (!showEventPicker()) {
    <ninety-meeting-bot-calendar-section
      dataCyPrefix="add-meeting-bot-dialog"
      [addMeetingAgentControl]="addMeetingAgentControl"
      [pickedEvent]="selectedCalendarEvent()"
      (openPicker)="openEventPicker()"
      (openProviderChooser)="onOpenProviderChooser($event)" />

    @if (!selectedCalendarEvent()) {
      @if (showCalendarOption()) {
        <span class="text-light meeting-link-divider">or</span>
      }
      <terra-form-field class="meeting-link-field">
        <terra-form-label>Add conference link</terra-form-label>
        <terra-text-input
          placeholder="https://zoom.us/j/..."
          data-cy="add-meeting-bot-dialog_meeting-link-input"
          [formControl]="meetingLinkControl">
          @if (meetingLinkControl.valid && meetingLinkControl.value) {
            <terra-input-suffix>
              <terra-icon
                class="meeting-link-valid-icon"
                icon="check-circle"
                variant="fill"
                data-cy="add-meeting-bot-dialog_meeting-link-valid-icon" />
            </terra-input-suffix>
          }
        </terra-text-input>
        @if (meetingLinkControl.invalid && meetingLinkControl.touched) {
          <terra-error data-cy="add-meeting-bot-dialog_meeting-link-error">
            @if (meetingLinkControl.errors?.required) {
              Enter a meeting link
            } @else if (meetingLinkControl.errors?.unsupportedPlatform) {
              Enter a valid Zoom, Google Meet, Microsoft Teams, Webex, or GoToMeeting link
            } @else {
              Enter a valid URL
            }
          </terra-error>
        }
      </terra-form-field>
    }
  } @else {
    <ninety-select-calendar-event-dialog
      [connectionId]="activeCalendarConnectionId()!"
      [calendarService]="calendarEventsService()"
      [selectedEventId]="selectedCalendarEvent()?.id"
      (closed)="onEventPickerClosed($event)" />
  }
</mat-dialog-content>

@if (!showEventPicker() && !showProviderChooser()) {
  <mat-dialog-actions align="end">
    <ninety-button-row>
      <ninety-button stroked data-cy="add-meeting-bot-dialog_cancel-button" (click)="cancel()">Cancel</ninety-button>
      <ninety-button
        filled
        primary
        [disabled]="!canAdd()"
        data-cy="add-meeting-bot-dialog_confirm-button"
        (click)="add()">
        Add
      </ninety-button>
    </ninety-button-row>
  </mat-dialog-actions>
}
